import { Role } from "entities/user/role";

export interface MenuResource {
  key: string;
  label: string;
  parent?: string;
  isSection?: boolean;
}

export const MENU_RESOURCES: MenuResource[] = [
  { key: "Dashboard", label: "Dashboard" },
  { key: "users", label: "Users" },
  { key: "gift_cards_section", label: "Gift Cards", isSection: true },
  {
    key: "gift_card_templates",
    label: "Gift Card Templates",
    parent: "gift_cards_section",
  },
  { key: "gift_cards", label: "Gift Cards", parent: "gift_cards_section" },
  {
    key: "gift_card_campaigns",
    label: "Gift Card Campaigns",
    parent: "gift_cards_section",
  },
  { key: "waitlist_items", label: "Waitlist Items" },
  { key: "surveys_section", label: "Surveys", isSection: true },
  { key: "surveys", label: "Surveys", parent: "surveys_section" },
  { key: "survey_rewards", label: "Survey Rewards", parent: "surveys_section" },
  { key: "loyalty_section", label: "Loyalty", isSection: true },
  { key: "tiers", label: "Tiers", parent: "loyalty_section" },
  { key: "xp_earnings", label: "XP Earnings", parent: "loyalty_section" },
  { key: "xp_reductions", label: "XP Reductions", parent: "loyalty_section" },
  {
    key: "loyalty_rewards",
    label: "Loyalty Rewards",
    parent: "loyalty_section",
  },
  {
    key: "coin_earning_rewards",
    label: "Coin Earning Rewards",
    parent: "loyalty_section",
  },
  { key: "coin_earnings", label: "Coin Earnings", parent: "loyalty_section" },
  { key: "coin_spendings", label: "Coin Spendings", parent: "loyalty_section" },
  { key: "widget", label: "Widget", parent: "loyalty_section" },
  { key: "articles_section", label: "Articles", isSection: true },
  { key: "articles", label: "Articles", parent: "articles_section" },
  {
    key: "product_segments",
    label: "Product Segments",
    parent: "articles_section",
  },
  { key: "categories", label: "Categories", parent: "articles_section" },
  { key: "sale_announcements", label: "Sale Announcements" },
  { key: "polls", label: "Polls" },
  { key: "comments", label: "Comments" },
  { key: "likes", label: "Likes" },
  { key: "sanity_checkers", label: "Sanity Checkers" },
  { key: "plans", label: "Plans" },
  { key: "subscriptions", label: "Subscriptions" },
  { key: "invoices", label: "Invoices" },
  { key: "tea_addons_section", label: "Tea Addons", isSection: true },
  {
    key: "tea_addon_subscriptions",
    label: "Tea Addon Subscriptions",
    parent: "tea_addons_section",
  },
  {
    key: "tea_addon_subscription_analytics",
    label: "Subscription Analytics",
    parent: "tea_addons_section",
  },
  { key: "tea_addons", label: "Tea Addons", parent: "tea_addons_section" },
  {
    key: "tea_addon_renewal_runs",
    label: "Renewal Runs",
    parent: "tea_addons_section",
  },
  { key: "public_site_settings", label: "Public Site Settings" },
  { key: "zendesk", label: "Zendesk" },
  { key: "cancel_flow_section", label: "Cancel Flow", isSection: true },
  {
    key: "cancel_dashboard",
    label: "Dashboard",
    parent: "cancel_flow_section",
  },
  {
    key: "offer_configurations",
    label: "Offer Configurations",
    parent: "cancel_flow_section",
  },
  {
    key: "cancellation_reasons",
    label: "Cancellation Reasons",
    parent: "cancel_flow_section",
  },
  {
    key: "cancel_sessions",
    label: "Cancel Sessions",
    parent: "cancel_flow_section",
  },
  { key: "cancel_reports", label: "Reports", parent: "cancel_flow_section" },
  { key: "cancel_people", label: "People", parent: "cancel_flow_section" },
];

export const FULL_ACCESS_ROLES: Role[] = ["admin"];

export const CONFIGURABLE_ROLES: Role[] = [
  "developer",
  "quality_assurance",
  "customer_experience",
  "marketer",
  "curator",
  "staff",
];

// Map hidden resources to the parent resource they inherit access from
export const HIDDEN_RESOURCE_PARENT_MAP: Record<string, string> = {
  poll_options: "polls",
  poll_answers: "polls",
  loyalty_order_problems: "sanity_checkers",
};
